import { TFunction, TOptions } from 'i18next';

import { languages, Locale } from './languages';

export function translationFactory(
  key: string | string[],
  options: {
    params?: TOptions;
    format?: (value: string) => string;
  } = {}
) {
  return (t: TFunction) => {
    const trans = t(key, options.params);

    return options.format ? options.format(trans) : trans;
  };
}

export function detectTranslation(
  key: ((t: TFunction) => string) | string,
  t: TFunction
) {
  return typeof key === 'function' ? key(t) : key;
}

export const isMatchLanguage = (userCountry: string, systemLang: string) => {
  if (languages[userCountry] == null) {
    return true;
  }

  return languages[userCountry].some(({ locale }) => locale === systemLang);
};

export const getLanguageByCountry = (userCountry: string): Locale =>
  languages[userCountry]?.[0].locale || Locale.ENGLISH;
